import {useState} from 'react'
import styled from 'styled-components'
import {Api} from '../lib/api'
import {Spotify} from '../lib/spotify'
import {Alert} from './Alert'
import {Button, ButtonGroup} from './Button'
import {Modal} from './Modal'
import {TextInput} from './TextInput'

const Form = styled.form``

export const MergePlaylistModal = ({
  onClose,
  onMerged,
  open = true,
  selected,
  userId
}: {
  open?: boolean
  onClose: () => void
  onMerged?: () => void
  selected: string[]
  userId: string
}) => {
  const [loading, setLoading] = useState(false)
  const [name, setName] = useState('')
  const [error, setError] = useState<string>()
  const valid = !!name

  const mergePlaylists = async () => {
    setLoading(true)
    const playlist = await Spotify.createPlaylist(userId, name)
    await Promise.all([
      Spotify.mergePlaylists(
        selected,
        playlist.id,
        true,
        ['added', 'asc'],
        false,
        true
      ),
      Api.add(playlist.id, {parents: selected, frontPage: false})
    ])
    setLoading(false)
  }

  return (
    <Modal open={open} onClose={onClose}>
      <Form
        onSubmit={async e => {
          e.preventDefault()
          setError(undefined)
          try {
            await mergePlaylists()
            if (onMerged) {
              onMerged()
            }
            onClose()
          } catch (e) {
            console.error(e)
            setError("Sorry I wasn't able to create a merged playlist")
          }
        }}
      >
        {error && <Alert type="polite">{error}</Alert>}
        <TextInput
          placeholder="Playlist Name"
          value={name}
          onChange={e => setName(e.target.value)}
        />

        <ButtonGroup>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="submit" disabled={!valid || loading}>
            Merge
          </Button>
        </ButtonGroup>
      </Form>
    </Modal>
  )
}
